<template>
  <v-container>
    <v-row class="pb-4">
      <v-col>
        <v-icon> mdi-cash-multiple </v-icon>
        <span class="headline mx-2">Approval Limits</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height"
      
      align="center" 
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>
    <template v-else>
      <v-row 
        v-if="edit"
      >
        <v-col cols="12">
          <v-text-field
            ref="levelOne"
            v-model="form.levelOneLimit"
            v-money="money"
            label="Level 1 Approval Limit"
            prefix="RM"
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            ref="levelTwo"
            v-model="form.levelTwoLimit"
            v-money="money"
            label="Level 2 Approval Limit"
            prefix="RM"
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            ref="levelThree"
            v-model="form.levelThreeLimit"
            v-money="money"
            label="Level 3 Approval Limit"
            prefix="RM"
          />
        </v-col>
      </v-row>
      <template v-else>
        <v-row>        
          <v-col
            cols="12"
            md="3" 
            xl="2"
          >
            <span class="font-weight-medium">Level One: </span> 
          </v-col>
          <v-col>
            RM {{ levelOneLimit }}
          </v-col>
        </v-row>      
        <v-row>        
          <v-col
            cols="12"
            md="3" 
            xl="2"
          >
            <span class="font-weight-medium">Level Two: </span> 
          </v-col>
          <v-col>
            RM {{ levelTwoLimit }}
          </v-col>
        </v-row>  
        <v-row>        
          <v-col
            cols="12"
            md="3" 
            xl="2"
          >
            <span class="font-weight-medium">Level Three: </span> 
          </v-col>
          <v-col>
            RM {{ levelThreeLimit }}
          </v-col>
        </v-row>   
      </template>
    </template>
    <v-card-actions v-if="$hasPermissionTo(['update user approval limits']) && !$store.state.isMyProfile">
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="info"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div>
    </v-card-actions>
  </v-container>
</template>

<script>
  import { VMoney } from 'v-money'

  export default {
    directives: { money: VMoney },
    props: {
      userUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        edit: false,
        loading: false,
        progressing: false,

        levelOneLimit: null,
        levelTwoLimit: null,
        levelThreeLimit: null,
        form: {
          levelOneLimit: 0,
          levelTwoLimit: 0,
          levelThreeLimit: 0,
        },

        money: {
          decimal: '.',
          thousands: ',',
          precision: 0,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    computed: {
      inited () {
        return this.levelOneLimit !== null && this.levelTwoLimit !== null && this.levelThreeLimit !== null
      },
      formLevelOneLimit () {
        return parseInt(this.form.levelOneLimit.replace(/,/g, ''))
      },
      formLevelTwoLimit () {
        return parseInt(this.form.levelTwoLimit.replace(/,/g, ''))
      },
      formLevelThreeLimit () {
        return parseInt(this.form.levelThreeLimit.replace(/,/g, ''))
      },
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserLimits()
          }
        },
      },
    },
    methods: {
      loadUserLimits () {
        this.loading = true

        this.$api.approvalLimits().list(this.userUid)
          .then(response => {
            this.setLimits(response.data)
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      submitForm () {
        this.progressing = true

        this.$api.approvalLimits().update(this.userUid, this.prepareFormData())
          .then(response => {
            if (response.status >= 200 && response.status < 300) {           
              this.$snack({
                message: response.data.status,
              })

              this.updated()
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
      editForm () {
        this.edit = true

        Object.keys(this.form).map(key => {
          this.form[key] = this[key]
        })
      
        // this function is called when vue has re-rendered the component.
        this.$nextTick(function () {
          this.$refs.levelOne.$el.getElementsByTagName('input')[0].value = this.levelOneLimit
          this.$refs.levelTwo.$el.getElementsByTagName('input')[0].value = this.levelTwoLimit
          this.$refs.levelThree.$el.getElementsByTagName('input')[0].value = this.levelThreeLimit   
        })
      },
      updated () {
        this.edit = false

        this.levelOneLimit = this.formLevelOneLimit
        this.levelTwoLimit = this.formLevelTwoLimit
        this.levelThreeLimit = this.formLevelThreeLimit
      },
      setLimits (limits) {
        limits.map(limit => {
          if (limit.type === 'level 1 approval limit') {
            this.levelOneLimit = limit.upper_limit || 0
          } else if (limit.type === 'level 2 approval limit') {
            this.levelTwoLimit = limit.upper_limit || 0
          } else if (limit.type === 'level 3 approval limit') {
            this.levelThreeLimit = limit.upper_limit || 0
          }
        })
      },
      prepareFormData () {
        return [
          {
            'type': 'level 1 approval limit',
            'upper_limit': this.formLevelOneLimit,
          },
          {
            'type': 'level 2 approval limit',
            'upper_limit': this.formLevelTwoLimit,
          },
          {
            'type': 'level 3 approval limit',
            'upper_limit': this.formLevelThreeLimit,
          },
        ]
      },
    },
  }
</script>
